module.exports = __webpack_public_path__ + "static/media/microscope.53e222f3.svg";